import React, { useState } from "react";
import clowds from "./images/clowds.png";
import TermsnConditions from "./TermsnConditions";

const Footer = () => {
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showContactUsModal, setShowContactUsModal] = useState(false);
  const openTermsModal = () => {
    showTermsModal ? setShowTermsModal(false) : setShowTermsModal(true);
  };

  const openContactModal = () => {
    showContactUsModal ? setShowContactUsModal(false) : setShowContactUsModal(true);
  };

  const checkTermsHandel = () => {};

  return (
    <>
      <hr />
      <div className="bg-[#212445]">
        <div className="h-full w-full bg-[#212445] grid  lg:grid-cols-4 lg:px-28 px-4 md:grid-cols-2 py-16 gap-8">
          <div className="my-auto">
            <img src={clowds} className=" mx-auto" />
          </div>

          <div>
            <ul className="text-white">
              <li className="text-2xl font-bold">My Account</li>
                <a className="cursor-pointer" href="mailto:hello.clowds@gmail.com">Contact Us</a>
              <li
                onClick={openTermsModal}
                className="mt-1 cursor-pointer text-lg"
              >
                Terms & Conditions
              </li>
              
            </ul>
          </div>

        </div>
        <hr className="py-10 w-full" />
      </div>

      {showTermsModal ? (
        <TermsnConditions
          modalTermsClose={() => {
            openTermsModal();
          }}
          button="Close"
          check={checkTermsHandel}
        />
      ) : (
        "" 
      )}

{/* {showContactUsModal ? (
        <ContactUs
          modalTermsClose={() => {
            openTermsModal();
          }}
          button="Close"
          check={checkTermsHandel}
        />
      ) : (
        ""
      )} */}
    </>
  );
};

export default Footer;
